import { fbt } from 'fbtee'
import { Check, UserPlus } from 'lucide-react'

type Status = 'friend' | 'incoming' | 'outgoing' | 'none'

interface Props {
  status: Status
  onAccept: () => void
  onAdd: () => void
}

export function FriendStatusAction({ status, onAccept, onAdd }: Props) {
  if (status === 'friend') {
    return (
      <span className="inline-flex items-center gap-1 text-xs text-muted-foreground">
        <Check className="size-3.5 text-primary" />
        {fbt('Friends', 'Label shown next to a user who is already a friend')}
      </span>
    )
  }
  if (status === 'incoming') {
    return (
      <button
        className="inline-flex items-center gap-1 text-xs text-muted-foreground cursor-pointer"
        onClick={onAccept}
      >
        <UserPlus className="size-3.5 text-primary" />
        {fbt('Accept', 'Button to accept an incoming friend request')}
      </button>
    )
  }
  if (status === 'outgoing') {
    return (
      <span className="text-xs text-muted-foreground">
        {fbt('Requested', 'Label shown when a friend request has been sent')}
      </span>
    )
  }
  return (
    <button
      className="inline-flex items-center gap-1 text-xs text-muted-foreground cursor-pointer"
      onClick={onAdd}
    >
      <UserPlus className="size-3.5 text-primary" />
      {fbt('Add', 'Button to send a friend request')}
    </button>
  )
}

// eslint-disable-next-line react-refresh/only-export-components -- intentional co-located helper, see CLAUDE.md
export function getFriendStatus(
  uid: string,
  friendIds: Set<string>,
  incomingIds: Set<string>,
  outgoingIds: Set<string>,
): Status {
  if (friendIds.has(uid)) return 'friend'
  if (incomingIds.has(uid)) return 'incoming'
  if (outgoingIds.has(uid)) return 'outgoing'
  return 'none'
}
